"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, /**
 * Error which indicates a timeout
 */ "default", {
    enumerable: true,
    get: function() {
        return TimeoutError;
    }
});
let TimeoutError = class TimeoutError extends Error {
    /**
   * Constructs the timeout error
   * @param {String} message error message
   */ constructor(message){
        super(message);
        this.name = "TimeoutError";
    }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIjxhbm9uPiJdLCJzb3VyY2VzQ29udGVudCI6WyIndXNlIHN0cmljdCc7XG5cbi8qKlxuICogRXJyb3Igd2hpY2ggaW5kaWNhdGVzIGEgdGltZW91dFxuICovXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBUaW1lb3V0RXJyb3IgZXh0ZW5kcyBFcnJvciB7XG5cbiAgLyoqXG4gICAqIENvbnN0cnVjdHMgdGhlIHRpbWVvdXQgZXJyb3JcbiAgICogQHBhcmFtIHtTdHJpbmd9IG1lc3NhZ2UgZXJyb3IgbWVzc2FnZVxuICAgKi9cbiAgY29uc3RydWN0b3IobWVzc2FnZSkge1xuICAgIHN1cGVyKG1lc3NhZ2UpO1xuICAgIHRoaXMubmFtZSA9ICdUaW1lb3V0RXJyb3InO1xuICB9XG5cbn1cbiJdLCJuYW1lcyI6WyJUaW1lb3V0RXJyb3IiLCJFcnJvciIsImNvbnN0cnVjdG9yIiwibWVzc2FnZSIsIm5hbWUiXSwibWFwcGluZ3MiOiJBQUFBOzs7OytCQUVBOztDQUVDLEdBQ0Q7OztlQUFxQkE7OztBQUFOLElBQUEsQUFBTUEsZUFBTixNQUFNQSxxQkFBcUJDO0lBRXhDOzs7R0FHQyxHQUNEQyxZQUFZQyxPQUFPLENBQUU7UUFDbkIsS0FBSyxDQUFDQTtRQUNOLElBQUksQ0FBQ0MsSUFBSSxHQUFHO0lBQ2Q7QUFFRiJ9